import T6 from "../../components/ExcerciseTypes/TypeIn/T6";
import T6v2 from "../../components/ExcerciseTypes/TypeIn/T6v2";
import Circle_Write from "../../components/ExcerciseTypes/Circle_Write";
import MatchDots from "../../components/ExcerciseTypes/LineTo/MatchDots";
import UI from "../../components/ExcerciseTypes/Design/UserInterface";
const json = {
  6: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E1",
    audio: "Audios/fpt_ai/tranh-chay.mp3",
    autoPlay: true,
    video: "",
    recorder: true,
    // exerciseKey: "/img/FriendsPlus/Page4/Key/E1answerKey.jpg",
    component: T6,
    isHiddenCheck: true,
    hideBtnFooter: true,
    stylesTextInput: {},
    textareaStyle: {
      paddingTop: "5px",
      width: 850,
    },
    inputSize: 500,
    titleQuestion: [
      {
        num: "",
        title: `
        
		
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em hãy điền vào dòng trống dưới đây, mô tả nội dung tranh minh họa theo gợi ý:<br>
        Tranh vẽ một đường chạy, trên đó có nhiều bạn đang thi chạy. Hai bạn chạy đầu tiên nhìn rất giống nhau nhưng có bạn chạy nhanh hơn, có bạn chạy chậm hơn. Xung quanh là bạn bè các bạn đang cổ vũ rất nhiệt tình.<br>
        <div><video src="Audios/fpt_ai/guide/p17_e6.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>
          Sinh đôi: Sinh ra trong cùng một lần, thành một đôi.
        </span>
        <video src="Audios/fpt_ai/TraCuu/Sinh-doi.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    questionImage: [[{ url: "img/FriendsPlus/Page16/E2/a.jpg" }]],
    // hideBtnFooter: true,
    questions: [
      {
        title: `
        <img src='img/FriendsPlus/Page16/E2/a.jpg' style='height:10cm;margin-left:5px' /><br>
        
        <div style='margin-left: 50px; margin-top: 30px'>
        <b>Nội dung tranh minh họa: </b><br>
        <textarea id='0' rows="5" ></textarea></div>
              
        `,
        answer: [],
      },
    ],
  },
  7: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "Audios/fpt_ai/hai-anh-em-sinh-doi.mp3",
    video: "",
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page17/Key/E3answerKey.png",
    component: Circle_Write,
    autoPlay: true,
    hideBtnFooter: true,
    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src="Audios/fpt_ai/tieu_de_p3_e3.mp3"  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
	
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em hãy nghe giọng đọc mẫu câu chuyện <b>Anh em sinh đôi</b> và đọc theo nhé.
        <div><video src="Audios/fpt_ai/guide/p17_e7.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>
          Sinh đôi: Sinh ra trong cùng một lần, thành một đôi.
        </span>
        <video src="Audios/fpt_ai/TraCuu/Sinh-doi.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    textareaStyle: {
      paddingTop: "5px",
      width: 750,
    },
    question: {
      Write: {
        isHiddenCheck: true,
        inputStyle: { width: 750, fontSize: 22, height: 200 },
        answers: [""],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {
          border: "2px solid white",
          borderRadius: "50%",
          fontWeight: "bold",
        },
        // initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
        selectWordStyle: {
          padding: "0",
          border: "2px solid",
          borderColor: "gray",
        },
        limitSelect: 1,
        listWords: [
          `A|. <br> B|. <br> C|. `,
          `A. <br> B. <br> C. <br> D.`,
          `A. <br> B. <br> C. <br> D.`,
        ],
        answers: ["0-12"],

        initialValue: [],
      },
      Layout: `
    <img src='/img/FriendsPlus/Page16/E2/1.jpg' style='height:8cm;margin-left:50px' />
    <div style='width:20cm;margin-left:50px;font-size:22px'>
          &emsp;Khánh và Long là anh em sinh đôi. Hai anh em giống nhau như đúc. Hồi
          nhỏ thấy mọi người không nhận ra ai là anh, ai là em, Long khoái chí lắm. Nhưng dần
          dần, Long không còn thấy thú vị nữa. Mỗi khi bị gọi nhầm tên,
          Long lại muốn kêu lên: "Tôi là Long, tôi chẳng giống ai hết.".
          <br>
          &emsp;Long cố gắng làm mọi thứ khác anh, từ cách nói, dáng đi đến trang phục, kiểu tóc. 
          Còn anh cậu chẳng bận tâm đến chuyện đó.
          <br>
          &emsp;Một lần, hai anh em tham gia hội thao của trường. Long vô cùng lo lắng. 
          Hai anh em mặc đồng phục và đội mũ giống hệt nhau, bạn bè lại cổ vũ nhầm mất thôi. 
          Nhưng khi thi đấu, Long nhận ra các bạn không nhầm lẫn chút nào. Các bạn cổ vũ Long 
          đuổi theo Khánh khi Khánh dẫn đầu đường chạy. Các bạn cuống quýt gọi Khánh thay thế khi thấy 
          Long nhăn nhó vì đau trong trận kéo co... Hội thao kết thúc trong nỗi ngạc nhiên ngập tràn của Long.
          <br>
          &emsp;Trên đường về, Long hỏi Vân: <br>
          &emsp;-	Sao hôm nay không ai hỏi nhầm chúng tớ nhỉ?
          <br>
          &emsp;Vân khúc khích<br>
          &emsp;-	Vì Khánh hay cười, còn cậu lúc nào cũng nghiêm túc.<br>
          &emsp;Vinh chen vào: <br>
          &emsp;- Cậu thì chậm rãi, Khánh thì nhanh nhẩu, sao nhầm được. <br>
          &emsp;Nghe Long thắc mắc về những lần bạn bè nhầm lẫn, các bạn cùng cười:<br>
          &emsp;- Nhìn xa thì tưởng giống nhau, chứ nhìn gần thì mỗi cậu một vẻ mà. Có lúc bọn tới còn giả vờ nhầm để trêu các cậu đấy. <br>
          &emsp;Anh Khánh lúc đó mới lên tiếng: <br>
          &emsp;- Đôi khi giống nhau cũng hay mà, chỉ cần không bị phạt nhầm là được.<br>
          &emsp;Tiếng cười rộn rã làm tan biến mọi thắc mắc của Long. Cậu cũng phá lên cười. Cậu hiểu ra: Cậu vẫn là cậu, anh Khánh vẫn là anh Khánh, hai anh em chỉ giống nhau bề ngoài thôi.

      <div style='text-align: end'>(Châu Khuê)</div>
    </div>
         `,
    },
  },
  1: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "Audios/fpt_ai/doc_hieu_1.mp3",
    autoPlay: true,
    video: "",
    // hideBtnFooter: true,
    textareaStyle: { width: 750, paddingTop: "5px" },
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page17/Key/E1answerKey.png",
    component: Circle_Write,
    textAlign: "center",
    // isTuLuan: true,
    // maxLength: 1,
    // inputSize: 81,
    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src="Audios/fpt_ai/tieu_de_p3_e3.mp3"  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        <b>Em hãy đọc kĩ đoạn đầu tiên của bài đọc. Sau đó kích chuột vào các câu văn giới thiệu về Long và Khánh.</b>
        <div><video src="Audios/fpt_ai/guide/p17_e1.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>
          Sinh đôi: Sinh ra trong cùng một lần, thành một đôi.
        </span>
        <video src="Audios/fpt_ai/TraCuu/Sinh-doi.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    question: {
      Write: {
        inputStyle: { width: 750, padding: 20 },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {},
        // initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
        selectWordStyle: { padding: "0", borderBottom: "2px solid black" },
        limitSelect: 2,
        listWords: [
          `&emsp; Khánh_và_Long_là_anh_em_sinh_đôi|. Hai_anh_em_giống_nhau_như_đúc. 
          Hồi_nhỏ_thấy_mọi_người_không_nhận_ra_ai_là_anh,_ai_là_em,_Long_khoái_chí_lắm. 
          Nhưng_dần_dần,_Long_không_còn_thấy_thú_vị_nữa. Mỗi_khi_bị_gọi_nhầm_tên,_Long_lại_muốn_kêu_lên:_"Tôi_là_Long,_tôi_chẳng_giống_ai_hết.|".
          `,
        ],
        answers: ['0-2', '0-6'],

        initialValue: [],
      },
      Layout: `
   
        <img src='/img/FriendsPlus/Page16/E2/1.jpg' style='height:8cm;margin-left:50px' />
       
        
        <div style='width:20cm;margin-left:50px;font-size:22px'>
              <input id=0 type='Circle'/>
          <div style='text-align: end'>(Châu Khuê)</div>
        </div>
        <div style='display:flex;margin-top:20px'>
        <img src='/img/FriendsPlus/images/b.jpg' style='height:15mm;margin-right:20px' />
        <div>
            <b style='color:rgb(151 30 17); '>1.</b>
            &ensp;Long và Khánh được giới thiệu như thế nào?
        </div>
     </div>
    
       
        `,
    }
  },

  2: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "Audios/fpt_ai/doc_hieu_2.mp3",
    autoPlay: true,
    video: "",
    // isHello:true,
    // isTuLuan:true,
    // hideBtnFooter: true,
    textareaStyle: { width: '10cm', paddingTop: "5px",marginBottom:-20,resize:'none', fontSize: 23 },
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page17/Key/E2answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src="Audios/fpt_ai/tieu_de_p3_e3.mp3"  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        <b>Em đọc kĩ 2 đoạn đầu của bài đọc, điền các câu văn thể hiện cảm xúc và hành động của Long khi thấy mình giống anh vào ô phù hợp.</b>
        <div><video src="Audios/fpt_ai/guide/p17_e2.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>
          Sinh đôi: Sinh ra trong cùng một lần, thành một đôi.
        </span>
        <video src="Audios/fpt_ai/TraCuu/Sinh-doi.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
        <img src='/img/FriendsPlus/Page16/E2/1.jpg' style='height:8cm;margin-left:50px' />
        <div style='width:20cm;margin-left:50px;font-size:22px'>
              &emsp;Khánh và Long là anh em sinh đôi. Hai anh em giống nhau như đúc. Hồi
              nhỏ thấy mọi người không nhận ra ai là anh, ai là em, Long khoái chí lắm. Nhưng dần
              dần, Long không còn thấy thú vị nữa. Mỗi khi bị gọi nhầm tên,
              Long lại muốn kêu lên: "Tôi là Long, tôi chẳng giống ai hết.".
              <br>
              &emsp;Long cố gắng làm mọi thứ khác anh, từ cách nói, dáng đi đến trang phục, kiểu tóc. 
              Còn anh cậu chẳng bận tâm đến chuyện đó.
             
    
          <div style='text-align: end'>(Châu Khuê)</div>
        </div>
    
        <div style='display:flex;margin-top:20px'>
          <img src='/img/FriendsPlus/images/b.jpg' style='height:15mm;margin-right:20px' />
          <div style='width:20cm'>
              <b style='color:rgb(151 30 17); '>2.</b>
              &ensp;Những chi tiết nào thể hiện cảm xúc và hành động của Long khi thấy mình giống anh?<br>
              <table style='width:20cm;border:1px solid black;border-collapse: collapse;'>
                <tr style='border: 1px solid black;'>
                  <th style='border: 1px solid black;width:10cm;text-align:center;padding:5px 0px'>Cảm xúc của Long</th>
                  <th style='border: 1px solid black;width:10cm;text-align:center;padding:5px 0px'>Hành động của Long</th>
                  
                </tr>
                <tr style='border: 1px solid black;'>
                  <td style='border: 1px solid black'><textarea initialValue='1' id=0 rows='5'></td>
                  <td style='border: 1px solid black'><textarea id=1 rows='5'></textarea></td>
                  
                </tr>
               
            </table>
        </div>
        `,
        answer: [
          
          "Hồi nhỏ, thấy mọi người không nhận ra ai là anh, ai là em, Long khoái chí lắm. Nhưng dần dần, Long không còn thấy thú vị nữa.",
          "Long cố gắng làm mọi thứ khác anh, từ cách nói, dáng đi đến trang phục, kiểu tóc.",
        ],
      },
    ],
  },
  3: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "Audios/fpt_ai/doc_hieu_3.mp3",
    autoPlay: true,
    video: "",
    // hideBtnFooter: true,
    isTuLuan:true,
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page17/Key/E3answerKey.png",
    component: T6,
    // textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    stylesTextInput: {
      // background: "none",
      // borderBottom: "none",
      fontSize: 22,
      height: 28,
      // textTransform: "uppercase",
      borderStyle: "2px dotted",
      textAlign: "center",
    },
    textareaStyle: {
      // background: 'none',
      paddingTop: 5,
      width: 750,
      fontSize: 22,
      height: 100,
      textAlign: "left",
    },
    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src="Audios/fpt_ai/tieu_de_p3_e3.mp3"  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
	
		`,
        color: "rgb(3, 103, 181)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em hãy đọc lại bài, lựa chọn câu trả lời theo ý kiến cá nhân, có lí giải phù hợp, sau đó gõ chữ vào các dòng trống.
        <div><video src="Audios/fpt_ai/guide/p17_e3.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>
          Sinh đôi: Sinh ra trong cùng một lần, thành một đôi.
        </span>
        <video src="Audios/fpt_ai/TraCuu/Sinh-doi.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,

    questions: [
      {
        title: `
        <img src='/img/FriendsPlus/Page16/E2/1.jpg' style='height:8cm;margin-left:50px' />
        <div style='width:20cm;margin-left:50px;font-size:22px'>
              &emsp;Khánh và Long là anh em sinh đôi. Hai anh em giống nhau như đúc. Hồi
              nhỏ thấy mọi người không nhận ra ai là anh, ai là em, Long khoái chí lắm. Nhưng dần
              dần, Long không còn thấy thú vị nữa. Mỗi khi bị gọi nhầm tên,
              Long lại muốn kêu lên: "Tôi là Long, tôi chẳng giống ai hết.".
              <br>
              &emsp;Long cố gắng làm mọi thứ khác anh, từ cách nói, dáng đi đến trang phục, kiểu tóc. 
              Còn anh cậu chẳng bận tâm đến chuyện đó.
              <br>
              &emsp;Một lần, hai anh em tham gia hội thao của trường. Long vô cùng lo lắng. 
              Hai anh em mặc đồng phục và đội mũ giống hệt nhau, bạn bè lại cổ vũ nhầm mất thôi. 
              Nhưng khi thi đấu, Long nhận ra các bạn không nhầm lẫn chút nào. Các bạn cổ vũ Long 
              đuổi theo Khánh khi Khánh dẫn đầu đường chạy. Các bạn cuống quýt gọi Khánh thay thế khi thấy 
              Long nhăn nhó vì đau trong trận kéo co... Hội thao kết thúc trong nỗi ngạc nhiên ngập tràn của Long.
              <br>
              &emsp;Trên đường về, Long hỏi Vân: <br>
              &emsp;-	Sao hôm nay không ai hỏi nhầm chúng tớ nhỉ?
              <br>
              &emsp;Vân khúc khích<br>
              &emsp;-	Vì Khánh hay cười, còn cậu lúc nào cũng nghiêm túc.<br>
              &emsp;Vĩng chen vào: <br>
              &emsp;- Cậu thì chậm rãi, Khánh thì nhanh nhẩu, sao nhầm được. <br>
              &emsp;Nghe Long thắc mắc về những lần bạn bè nhầm lẫn, các bạn cùng cười:<br>
              &emsp;- Nhìn xa thì tưởng giống nhau, chứ nhìn gần thì mỗi cậu một vẻ mà. Có lúc bọn tới còn giả vờ nhầm để trêu các cậu đấy. <br>
              &emsp;Anh Khánh lúc đó mới lên tiếng: <br>
              &emsp;- Đôi khi giống nhau cũng hay mà, chỉ cần không bị phạt nhầm là được.<br>
              &emsp;Tiếng cười rộn rã làm tan biến mọi thắc mắc của Long. Cậu cũng phá lên cười. Cậu hiểu ra: Cậu vẫn là cậu, anh Khánh vẫn là anh Khánh, hai anh em chỉ giống nhau bề ngoài thôi.
    
          <div style='text-align: end'>(Châu Khuê)</div>
        </div>
    
        <div style='display:flex;margin-top:20px'>
      <img src='/img/FriendsPlus/images/b.jpg' style='height:15mm;margin-right:20px' />
      <div style='width:20cm'>
        <div style='margin-top:12px ;margin-bottom:10px'>
          <b style='color:rgb(151 30 17)'>3.</b>&ensp;Theo em vì sao Long không muốn giống anh của mình? Chọn câu trả lời dưới đây hoặc nêu ý kiến của em.<br>
          <div style='display:flex;margin-left: 25px;'>
            <div style='margin:0px 15px'>
            <b>A&ensp;</b>  Vì Long không thích bị mọi người gọi nhầm.<br>
            <b>B&ensp;</b>  Vì Long cảm thấy phiền hà khi giống người khác.<br>
            <b>C&ensp;</b>  Vì Long muốn khẳng định vẻ riêng của mình.
            </div>
          </div><br>
          <b>Đáp án em chọn:&ensp;</b><input id='0' width ='100px'><br>
          
          <b>Ý kiến của em (nếu có):&ensp;</b><br>
          <div><span style='font-size:20px; color: rgb(151 30 17)'>*Nếu không có hãy viết <i>Không</i>.</span></div>
          <textarea id='1' rows='3'>
      </div>
    </div>
        `,
        answer: ["A / B / C", ""],
      },
    ],
  },
  4: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "Audios/fpt_ai/doc_hieu_4.mp3",
    autoPlay: true,
    video: "",
    // hideBtnFooter: true,
    textareaStyle: { width: 750, paddingTop: "5px", fontSize: 23 },
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page17/Key/E4answerKey.png",
    component: Circle_Write,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,
    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src="Audios/fpt_ai/tieu_de_p3_e3.mp3"  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em đọc kĩ lời thoại của Vân và Vinh, sau đó kích chuột vào phương án trả lời phù hợp.
        <div><video src="Audios/fpt_ai/guide/p17_e4.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>
          Sinh đôi: Sinh ra trong cùng một lần, thành một đôi.
        </span>
        <video src="Audios/fpt_ai/TraCuu/Sinh-doi.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    question: {
      Write: {
        inputStyle: { width: 750, padding: 20 },
        answers: [],
        initialValue: [],
      },
      Circle: {
        initialWordStyle: {padding: 5,fontWeight:"bold", border:"2px solid white", borderRadius:"50%"},
        // initialWordSt<yle: { fontWeight: 'bold', border: 'none',  borderColor: 'transparent' },
        selectWordStyle: { padding: 5,fontWeight:"bold", border: "2px solid black",borderRadius:"50%" },
        limitSelect: 1,
        listWords: [
          `A <br> B <br> C <br> 
          `,
        ],
        answers: ['0-4'],

        initialValue: [],
      },
      Layout: `
        <img src='/img/FriendsPlus/Page16/E2/1.jpg' style='height:8cm;margin-left:50px' />
        <div style='width:20cm;margin-left:50px;font-size:22px'>
            &emsp;Trên đường về, Long hỏi Vân: <br>
            &emsp;-	Sao hôm nay không ai hỏi nhầm chúng tớ nhỉ?
            <br>
            &emsp;Vân khúc khích<br>
            &emsp;-	Vì Khánh hay cười, còn cậu lúc nào cũng nghiêm túc.<br>
            &emsp;Vinh chen vào: <br>
            &emsp;- Cậu thì chậm rãi, Khánh thì nhanh nhẩu, sao nhầm được. <br>
            &emsp;Nghe Long thắc mắc về những lần bạn bè nhầm lẫn, các bạn cùng cười:<br>
            &emsp;- Nhìn xa thì tưởng giống nhau, chứ nhìn gần thì mỗi cậu một vẻ mà. Có lúc bọn tới còn giả vờ nhầm để trêu các cậu đấy. <br>
            &emsp;Anh Khánh lúc đó mới lên tiếng: <br>
            &emsp;- Đôi khi giống nhau cũng hay mà, chỉ cần không bị phạt nhầm là được.<br>
          <div style='text-align: end'>(Châu Khuê)</div>
        </div>
      <div style='display:flex;margin-top:20px'>
        <img src='/img/FriendsPlus/images/b.jpg' style='height:15mm;margin-right:20px' />
        <div>
            <b style='color:rgb(151 30 17); '>4.</b>
            &ensp;Nhờ nói chuyện với các bạn, Long đã nhận ra mình khác anh như thế nào? 
            <div style='display:flex;line-height:47px'>
              <div>
                <input id='0' type='Circle'/>
              </div>
              <div style='margin-left:5px'>
                Hai anh em giống nhau đặc điểm, tính cách, thói quen còn ngoại hình khác nhau.<br>
                Hai anh em giống nhau ngoại hình còn đặc điểm, tính cách, thói quen,… khác nhau.<br>
                Hai anh em khác nhau cả ngoại hình và đặc điểm, tính cách, thói quen,… 
              </div>
            </div>
        </div>
     </div>
     
    
       
        `,
    }
  },
  5: {
    unit: "Unit Starter",
    id: "FP8-WB-demo-2023-US-P4-E2",
    audio: "Audios/fpt_ai/doc_hieu_5.mp3",
    autoPlay: true,
    video: "",
    isTuLuan:true,
    // hideBtnFooter: true,
    textareaStyle: { width: 300, paddingTop: "5px", fontSize: 21 },
    // recorder: true,
    exerciseKey: "/img/FriendsPlus/Page17/Key/E5answerKey.png",
    component: T6,
    textAlign: "center",
    // maxLength: 1,
    // inputSize: 81,

    titleQuestion: [
      {
        num: "",
        title: `
        <headphone src="Audios/fpt_ai/tieu_de_p3_e3.mp3"  imageUrl="img/FriendsPlus/images/c.jpg"></headphone> <span style='text-align:center;font-weight:bold;color:#5d4c80'>ANH EM SINH ĐÔI</span>
				`,
        color: "rgb(29,193,215)",
      },
    ],
    guideModal: [
      // nội dung nút hướng dẫn
      {
        title: "Hướng dẫn",
        description: `<span>
        Em hãy tìm chi tiết thể hiện hành động, lời nói của Long và Khánh, sau đó em gõ nhận xét về Long và Khánh qua hành động và lời nói đó vào các dòng trống.
        <div><video src="Audios/fpt_ai/guide/p17_e5.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    newWords: [
      {
        title: "Tra cứu",
        description: `
        <span>
          Sinh đôi: Sinh ra trong cùng một lần, thành một đôi.
        </span>
        <video src="Audios/fpt_ai/TraCuu/Sinh-doi.mp3" controls style="width: 100%; height: 2cm"></video>      
        `,
      },
    ],
    questionImage: [],
    // hideBtnFooter: true,
    isHiddenCheck: true,
    // isEssay: true,
    questions: [
      {
        title: `
        <img src='/img/FriendsPlus/Page16/E2/1.jpg' style='height:8cm;margin-left:50px' />
        <div style='width:20cm;margin-left:50px;font-size:22px'>
              &emsp;Khánh và Long là anh em sinh đôi. Hai anh em giống nhau như đúc. Hồi
              nhỏ thấy mọi người không nhận ra ai là anh, ai là em, Long khoái chí lắm. Nhưng dần
              dần, Long không còn thấy thú vị nữa. Mỗi khi bị gọi nhầm tên,
              Long lại muốn kêu lên: "Tôi là Long, tôi chẳng giống ai hết.".
              <br>
              &emsp;Long cố gắng làm mọi thứ khác anh, từ cách nói, dáng đi đến trang phục, kiểu tóc. 
              Còn anh cậu chẳng bận tâm đến chuyện đó.
              <br>
              &emsp;Một lần, hai anh em tham gia hội thao của trường. Long vô cùng lo lắng. 
              Hai anh em mặc đồng phục và đội mũ giống hệt nhau, bạn bè lại cổ vũ nhầm mất thôi. 
              Nhưng khi thi đấu, Long nhận ra các bạn không nhầm lẫn chút nào. Các bạn cổ vũ Long 
              đuổi theo Khánh khi Khánh dẫn đầu đường chạy. Các bạn cuống quýt gọi Khánh thay thế khi thấy 
              Long nhăn nhó vì đau trong trận kéo co... Hội thao kết thúc trong nỗi ngạc nhiên ngập tràn của Long.
              <br>
              &emsp;Trên đường về, Long hỏi Vân: <br>
              &emsp;-	Sao hôm nay không ai hỏi nhầm chúng tớ nhỉ?
              <br>
              &emsp;Vân khúc khích<br>
              &emsp;-	Vì Khánh hay cười, còn cậu lúc nào cũng nghiêm túc.<br>
              &emsp;Vĩng chen vào: <br>
              &emsp;- Cậu thì chậm rãi, Khánh thì nhanh nhẩu, sao nhầm được. <br>
              &emsp;Nghe Long thắc mắc về những lần bạn bè nhầm lẫn, các bạn cùng cười:<br>
              &emsp;- Nhìn xa thì tưởng giống nhau, chứ nhìn gần thì mỗi cậu một vẻ mà. Có lúc bọn tới còn giả vờ nhầm để trêu các cậu đấy. <br>
              &emsp;Anh Khánh lúc đó mới lên tiếng: <br>
              &emsp;- Đôi khi giống nhau cũng hay mà, chỉ cần không bị phạt nhầm là được.<br>
              &emsp;Tiếng cười rộn rã làm tan biến mọi thắc mắc của Long. Cậu cũng phá lên cười. Cậu hiểu ra: Cậu vẫn là cậu, anh Khánh vẫn là anh Khánh, hai anh em chỉ giống nhau bề ngoài thôi.
    
          <div style='text-align: end'>(Châu Khuê)</div>
        </div>
    
        <div style='display:flex;margin-top:20px'>
          <img src='/img/FriendsPlus/images/b.jpg' style='height:15mm;margin-right:20px' />
          <div style='width:20cm'>
              <b style='color:rgb(151 30 17); '>5.</b>
              &ensp; Nhận xét về đặc điểm của Long và Khánh thể hiện qua hành động, lời nói của từng nhân vật.<br>
              <div>
              <table style="border-collapse: collapse; width: 100%; max-width: 750px">

                  <tr style="">
                    <td style="border: 1px solid black; padding: 10px; text-align: left;"></td>
                    <td style="border: 1px solid black; padding: 10px; text-align: center; background-color: rgb(104,223,245)"><b>Long</b></td>
                    <td style="border: 1px solid black; padding: 10px; text-align: center; background-color: rgb(104,223,245)"><b>Khánh</b></td>
                  </tr>
                  <tr style="">
                    <td style="border: 1px solid black; padding: 10px; text-align: center; background-color: rgb(104,223,245)"><b>Hành động</b></td>
                    <td style="border: 1px solid black; padding: 10px; text-align: left;"><textarea id='0' rows="5" ></textarea></td>
                    <td style="border: 1px solid black; padding: 10px; text-align: left;"><textarea id='1' rows="5" ></textarea></td>
                    </tr>
                  <tr style="">
                  <td style="border: 1px solid black; padding: 10px; text-align: center; background-color: rgb(104,223,245)"><b>Lời nói</b></td>
                  <td style="border: 1px solid black; padding: 10px; text-align: left;"><textarea id='2' rows="5" ></textarea></td>
                  <td style="border: 1px solid black; padding: 10px; text-align: left;"><textarea id='3' rows="5" ></textarea></td>
                  </tr>

            </table>
              </div><br>
              <b>Nhận xét:</b><br>
              <b>Long:</b><textarea id='4' rows='4' width='750px'></textarea><br>
              <b>Khánh:</b><textarea id='5' rows='4' width='750px'></textarea>
        </div>
        `,
        answer: [
          // "",
          // "",
          // "",
          // "",
          // "",
          // "",
          "Cố gắng làm mọi thứ khác anh; Hỏi bạn bè nguyên nhân các bạn không nhầm lẫn khi cổ vũ mình và anh Khánh; Phá lên cười khi nhận ra hai anh em chỉ giống nhau bề ngoài, thực chất mỗi người một vẻ, không ai giống ai.",
          "Không bận tâm đến việc hai anh em giống nhau; Cười khi nghe các bạn nhận xét về mình và em Long.",
          "Tôi là Long, tôi chẳng giống ai hết.",
          "Đôi khi giống nhau cũng hay mà, chỉ cần không bị phạt nhầm là được.",
          "Hành động, lời nói của Long thể hiện Long là người khá nghiêm túc, chậm rãi, hay suy nghĩ. Long luôn muốn khẳng định bản thân, muốn mình đặc biệt và là duy nhất.",
          "Khánh là người nhanh nhẹn, hài hước, suy nghĩ đơn giản, không quá coi trọng những tương đồng về hình thức, hiểu rõ việc mình và em thực chất rất khác biệt về tính cách nên việc giống nhau về hình thức không khiến Khánh phải suy nghĩ.",
        ],
      },
    ],
  },
};

export default json;
